import './vendor';
import helpers from './helpers';
import {ieFix} from './vendor/ie-fix';
import {vhFix} from './vendor/vh-fix';
import {footerHeight} from './vendor/footer-height';
import header from './components/header';

import './components/brands';

import inView from 'in-view';

ieFix();
vhFix();
footerHeight();

header.init();

// eslint-disable-next-line no-unused-vars,no-undef
new Swiper('.firstscreen_swiper', {
	slidesPerView: 1,
	spaceBetween: 0,
	allowTouchMove: false,
	effect: 'fade',
	navigation: {
    nextEl: '.firstscreen_swiper .swiper-button-next',
    prevEl: '.firstscreen_swiper .swiper-button-prev',
  }
});

$('.open-contact-modal').on('click', e => {
	e.preventDefault();
	$('#consultModal').modal('show')
});

$(window).on('scroll', () => {
	if ($(window).scrollTop() >= 2) {
		$('.header').addClass('slide-top');
	}

	if ($(window).scrollTop() >= 300) {
		$('body').addClass('fixed-header');
	}
	else {
		$('body').removeClass('fixed-header');
		$('.header').removeClass('slide-top');
	}
});

let numCounter = () => {
	if( $('#section__6').hasClass('animated') ) return;
	// Find the 'count this' class on the page and animate it
	$('.count-this').each(function () {
		// Start the counting from a specified number - in this case, 0!
	    $(this).prop('Counter',0).animate({
	        Counter: $(this).text()
	    }, {
	    	// Speed of counter in ms, default animation style
	        duration: 2000,
	        easing: 'swing',
	        step: function (now) {
	        	// Round up the number
	            $(this).text(Math.ceil(now));
	        }
	    });
	});
}

inView('#section__6')
	.on('enter', numCounter)
	.on('exit', e => {
		$(e).addClass('animated');
	});

$.each($('.slide-up[data-offset]'), (index, value) => {
	$(value).css('transform', `translate3d(0, ${$(value).data('offset')}, 0)`);
});

inView('.slide-up:not(.animated)')
  .on('enter', el => {
    $(el).css('transform', 'translateZ(0)');
  });

$('.main__menu, .footer .menu').on('click', 'a', (e) => {
	if( helpers.$body.hasClass('home') && e.target.hash ) {
		e.preventDefault();
		helpers.scrollTo($(e.target.hash), 800, -100);
	}
	else {
		window.location.href = `${themeData.home}/${e.target.hash}`;
		return true;
	}
});

let hash = window.location.hash;
if( hash ){
	helpers.scrollTo($(hash), 800, -100);
}

let cookieBlock = $('#cookie-block');
cookieBlock.find('#cookie-close').on('click', ()=>{
	cookieBlock.animate({opacity: 0}, 500, ()=>{ cookieBlock.remove() });
	helpers.setCookie('igree_cookie', 1, 365);
});

$('.video-content').on('click', (e) => {
	console.log(e.currentTarget.dataset.url);
	let iframeHtml = `<iframe src="${e.currentTarget.dataset.url}&autoplay=1" allow="autoplay"></iframe>`;
	$(e.currentTarget).html( iframeHtml );
});